import React, { useState, useEffect, useRef } from 'react'
import Select from 'react-select'
import { Link } from 'react-router-dom'

import uniqid from 'uniqid'

import Swal from 'sweetalert2'

import { WithContext as ReactTags } from 'react-tag-input'

import { getTokenInfo } from '../../../UseToken'

import Loader from '../../Loader/Loader'

import {api_crud_base, api_crud_route, data_interface, endpoints } from './Config'

import ASSECCKEditor from "../../ASSEC_CKEditor/ASSEC_CKEditor"

import SortableTree from 'react-sortable-tree'
import 'react-sortable-tree/style.css'

import DraggableDivImage from "../../DraggableDiv/DraggableDivImage"

import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	content_language,
	check_interface,
	handle_compressed_image_upload,
	replace_slug_string,
	translate
} from '../../../Utils'

import Hosts from '../../../Hosts'

import { language } from './Language'

export default function Regist(props) {

	const [, set_dados] = useState(null)
	const dados = useRef(null)

	const [date_creation, set_date_creation] = useState('') 
	const [date_modification, set_date_modification] = useState('') 
	const [date_publication, set_date_publication] = useState('') 
	const [date_avaiable, set_date_avaiable] = useState('') 

	const [lang, set_lang] = useState('pt')
	const [uid, ] = useState(uniqid())

	const [, setSlug] = useState(false);
	const [menus_avaiable, set_menus_avaiable] = useState([])

	const [isloading, setLoading] = useState(true)

	const [show_delete_button, set_show_delete_button] = useState(false)

	const [is_edit, set_is_edit] = useState(false)
	const [, setEditorLoaded] = useState(false)

	const [, setSelectedFile] = useState(null)

	const [treeData, setTreeData] = useState([]) 
	const [tags, setTags] = useState([]) 	

	const [suggestions, set_suggestions] = useState([])
	const [keycodes, ] = useState({comma: 188, enter: 13 })
    const [delimiters, ] = useState([keycodes.comma, keycodes.enter])

	const [refresh, setRefresh] = useState(0)

	const [dragId, setDragId] = useState()

	const [files_image, set_files_image] = useState([])
	const [image_base64, set_image_base64] = useState([])

	const [img_loader, set_img_loader] = useState([])

	const [files_doc, set_files_doc] = useState([])
	const [files_doc_name, set_files_doc_name] = useState([])

	let compareDataWithInterface = (data, d_interface) => { 
		
		data.id = check_interface(data.id, d_interface.id)

		data.info = check_interface(data.info, d_interface.info)
		data.info.companycode = check_interface(data.info.companycode, d_interface.info.companycode)
		data.info.name = check_interface(data.info.name, d_interface.info.name)
		data.info.type = check_interface(data.info.type, d_interface.info.type)
		data.info.layout = check_interface(data.info.layout, d_interface.info.layout)
		data.info.date = check_interface(data.info.date, d_interface.info.date)
		data.info.language = check_interface(data.info.language, d_interface.info.language)
		data.info.media = check_interface(data.info.media, d_interface.info.media)
		data.info.seo = check_interface(data.info.seo, d_interface.info.seo)
		data.info.tags = check_interface(data.info.tags, d_interface.info.tags)
		data.info.parent = check_interface(data.info.parent, d_interface.info.parent)
		data.info.order = check_interface(data.info.order, d_interface.info.order)
		data.info.slug = check_interface(data.info.slug, d_interface.info.slug)
		data.info.status = check_interface(data.info.status, d_interface.info.status)

		data.content = check_interface(data.content, d_interface.content)
		data.content[0].title = check_interface(data.content[0].title, d_interface.content[0].title)
		data.content[0].subtitle = check_interface(data.content[0].subtitle, d_interface.content[0].subtitle)
		data.content[0].abstract = check_interface(data.content[0].abstract, d_interface.content[0].abstract)
		data.content[0].text = check_interface(data.content[0].text, d_interface.content[0].text)
		data.content[0].media = check_interface(data.content[0].media, d_interface.content[0].media)
		data.content[0].align = check_interface(data.content[0].align, d_interface.content[0].align)
		data.content[0].link = check_interface(data.content[0].link, d_interface.content[0].link)
		data.content[0].language = check_interface(data.content[0].language, d_interface.content[0].language)

	}

	const handleDrag = (ev) => {
	  	setDragId(ev.currentTarget.id);
	};

	const handleDragOver = (ev) => {
		const { dataset } = ev.target;
		const { order, langid } = dataset

		if(order === undefined)
			return 

		let divs = dados.current.content[order].media.image
	
		const dragDiv = divs.find((div) => parseInt(div.id) === parseInt(dragId));
		const dropDiv = divs.find((div) => parseInt(div.id) === parseInt(ev.currentTarget.id));

		if(dragDiv !== undefined && dropDiv !== undefined) {
			const dragDivOrder = dragDiv.order;
			const dropDivOrder = dropDiv.order;

			let aux = []
			divs.forEach((div) => {
				if (div.id + '' === dragId + '') {
					div.order = dropDivOrder;
				}
				if (div.id + '' === ev.currentTarget.id + '') {
					div.order = dragDivOrder;
				}
				if(div !== undefined && div !== null)
					aux[div.order] = div
			});

			if(langid === '1') {
				// set_dados(dados.current.content[order].media.image = aux)
				dados.current.content[order].media.image = aux
			}
			else {
				// set_dados(dados.current.content[order].language[langid].media.image = aux)
				dados.current.content[order].language[langid].media.image = aux
			}

			setRefresh(refresh + 1)
		}
	};

	const handleDrop = (ev) => {
		//console.log('drop', ev)
	}

	const handleEdit = (order, id) => {
		set_dados(dados.current.content[order].media)
	};

	const handleRemove = (order, langid, id, link) => {

		// Swal.fire({
		// 	title: language[lang].delete_title,
		// 	text: language[lang].delete_text,
		// 	icon: 'question',
		// 	showCancelButton: true,
		// 	confirmButtonColor: '#0095e8',
		// 	cancelButtonColor: '#d9214e',
		// 	confirmButtonText: language[lang].delete_confirm,
		// 	cancelButtonText: language[lang].delete_cancel
		// })
		// .then((result) => {
		// 	if (result.isConfirmed) {

				if(langid === '1') {
					let aux = dados.current.content[order].media.image.filter(v => v.link !== link)
					
					aux.forEach((el, k) => {
						el.order = k
					})

					set_dados(dados.current.content[order].media.image = aux)
				}
				else {
					let aux = dados.current.content[order].language[langid].media.image.filter(v => v.link !== link)
					
					aux.forEach((el, k) => {
						el.order = k
					})

					set_dados(dados.current.content[order].language[langid].media.image = aux)
				}

		// 	}
		// })

	};

	const handleChangeContentMediaImage = (e) => {
		const { value, name, dataset } = e.target;
		const { order, link } = dataset

		dados.current.content[order].media.image.forEach(el => {
			if (el.link === link)
				el[name] = value
		})
		set_dados(dados.current.content[order].media.image)
		setRefresh(refresh + 1)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const fetch_web_categories = async () => {
		return await reqGET(`${api_crud_base}/web/category/${getTokenInfo().companycode}`)
			.then(res => {
				
				let suggestions_aux = []
				res.data.forEach((el) => {
					suggestions_aux.push({id: el.info.name, text: el.info.name})
				})
				set_suggestions(suggestions_aux)

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}


	const clean_data = async () => {		
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
	}

	useEffect(() => {
		clean_data();

		const order_menu = (parent, array, array2) => {
			let array_aux = array.filter(v => v.info.parent === parent)
			array_aux.forEach(v => {
				array2.push(v)
				order_menu(v.id, array, array2)
			})
		}
		
		const get_menus_avaiable = async () => {
			return await reqGET(`${api_crud_base}/web/content/type/${getTokenInfo().companycode}/content/name`)
				.then(async res => {
	
					let array_aux = []
					order_menu('0', res.data, array_aux)
					// set_menus_avaiable(array_aux);
	
					return await reqGET(`${api_crud_base}/web/content/type/${getTokenInfo().companycode}/partner/name`)
						.then(res2 => {
	
							//let array_aux = []
							array_aux.push({id: '', info: {name: '--- PARCEIROS ---'}})
							order_menu('0', res2.data, array_aux)
							set_menus_avaiable(array_aux);
							
						})
						.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
					
				})
				.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
		}

		set_lang(localStorage.getItem('lang'))

		get_menus_avaiable();

		fetch_web_categories()


		const fetch_id_info = async (id_serch) => {
			return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
				.then(res => {
	
					compareDataWithInterface(res.data[0], dados.current)
	
					set_dados(dados.current = res.data[0]);
					if(res.data[0].info['media'] !== undefined)
						setSelectedFile(res.data[0].info.media)
	
					let aux = []
					res.data[0].content.forEach((el, k) => {
						if(el.media !== undefined) {
							aux[k] = []
							aux[k][1] = el.media
						}
	
						if(el['language'] !== undefined && el['language'].length > 0) {
							el['language'].forEach((el_2) => {
								if(el_2 !== undefined && el_2 !== null) {
									if(el_2['media'] !== undefined && el_2['media'] !== null)
										aux[k][el_2.id] = [{image: [], doc: []}]
			
									if(el_2.media !== undefined)
										aux[k][el_2.id] = el_2.media
								}
							})
						}
					})
	
					//setSelectedFiles(aux)
	
					let aux_doc = []
					let i = 0
					aux.forEach((el, k) => {
						el.forEach((el_2, k_2) => {
							el_2.doc.forEach((el_3) => {
								if(aux_doc[k] === undefined)
									aux_doc[k] = []
								if(aux_doc[k][k_2] === undefined)
									aux_doc[k][k_2] = []
									
								aux_doc[k][k_2].push({ id: ++i, id_doc: el_3.id, title: el_3.name, link: el_3.link, visible: el_3.visible})
							})
						})
					})
					setTreeData(aux_doc)
					//console.log(res.data[0])
				})
				.catch(error => alert(error)/*TODO: GO TO FAIL FETCH*/)
		}


		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				set_is_edit(true)
				set_show_delete_button(true)

				set_image_base64([])
				set_files_doc_name([])

				fetch_id_info(props.location.state.item['id'])
					.then(() => {

						if(dados.current.info.date.creation !== undefined && dados.current.info.date.creation !== '') {
							let date_creation = new Date(dados.current.info.date.creation); 
							set_date_creation(date_creation.getDate().toString().padStart(2, '0') + '/' + (date_creation.getMonth() + 1).toString().padStart(2, '0') + '/' + date_creation.getFullYear())
						}
						if(dados.current.info.date.published !== undefined && dados.current.info.date.published !== '') {
							let date_publication = new Date(dados.current.info.date.published); 
							set_date_publication(date_publication.getDate().toString().padStart(2, '0') + '/' + (date_publication.getMonth() + 1).toString().padStart(2, '0') + '/' + date_publication.getFullYear())
						}
						if(dados.current.info.date.avaiable !== undefined && dados.current.info.date.avaiable !== '') {
							let date_avaiable = new Date(dados.current.info.date.avaiable); 
							set_date_avaiable(date_avaiable.getDate().toString().padStart(2, '0') + '/' + (date_avaiable.getMonth() + 1).toString().padStart(2, '0') + '/' + date_avaiable.getFullYear())
						}
						if(dados.current.info.date.modified !== undefined && dados.current.info.date.modified.length > 0) {
							let date_modification = new Date(dados.current.info.date.modified.pop());
							set_date_modification(date_modification.getDate().toString().padStart(2, '0') + '/' + (date_modification.getMonth() + 1).toString().padStart(2, '0') + '/' + date_modification.getFullYear())
						}

						setLoading(false)
						setEditorLoaded(true);
					})
				return			
			}

			// VAI REGISTAR
			if (test === undefined) {
				setLoading(false);
				return
			}
		} catch {
			// VAI REGISTAR

			//setRedirect(false);
			setLoading(false)

			clean_data()
				.then(() => {
					setEditorLoaded(true);
				})	
		
			return
		}

		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}


	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		var today_submit = new Date()

		if (is_edit === true) {
			//alert('Atualizar PUT')

			if(dados.current.info.uniqid !== undefined)
				delete dados.current.info.uniqid;
				
			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {

					change_item_from_menu('title', dados.current.info.name, dados.current.id)
						.then(() => {
							change_item_from_menu('slug', dados.current.info.slug, dados.current.id)
						})

						files_image.forEach(async (el_image) => {
							if(el_image !== null) {
								await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
							}
						})
						set_files_image([])
						set_image_base64([])
	
						files_doc.forEach(async (el_doc) => {
							if(el_doc !== null) {
								await uploadFilesDoc(el_doc.files, el_doc.order, 'doc', el_doc.langid, el_doc.lang)
							}
						})
						set_files_doc([])
						set_files_doc_name([])

					dados.current.info.date.modified.push(today_submit)
					reqPUT(api_crud_route, dados.current)
						.then(() => { 
							//props.history.push(endpoints.list) 

							Swal.fire(language[lang].edit_success, '', 'info')
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})
		} else {
			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					dados.current.info['uniqid'] = uid
					dados.current.info.date.creation = today_submit

					reqPOST(api_crud_route, dados.current)
						.then(() => { 

							reqGET(`${api_crud_base}/web/content/uniqid/${getTokenInfo().companycode}/${uid}`)
								.then(res => {
									console.log(res.data)
									dados.current.id = res.data[0].id

									files_image.forEach(async (el_image) => {
										if(el_image !== null) {
											await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
										}
									})
									set_files_image([])
									set_image_base64([])

									files_doc.forEach(async (el_doc) => {
										if(el_doc !== null) {
											await uploadFilesDoc(el_doc.files, el_doc.order, 'doc', el_doc.langid, el_doc.lang)
										}
									})
									set_files_doc([])
									set_files_doc_name([])

									set_is_edit(true)
									set_show_delete_button(true)
								})
								.catch(() => 404)

							Swal.fire(language[lang].insert_success, '', 'info')
							//props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})
		}
	}

	const remove_menu_childs = (menu, id) => {

		let menu2 = menu.filter(v => v.id_content !== id)
		if(menu2 !== undefined && menu2.length > 0) {
			menu2.forEach((value) => {
				if(value.children !== undefined && value['children'].length > 0) {
					let menu3 = value.children.filter(v => v.id_content !== id)
					if(menu3 !== undefined && menu3.length > 0) {
						return remove_menu_childs(menu3, id)
					}
					else {
						value.children = []
						return value.children
					}
				}
				else {
					return menu2
				} 
			})
		}
		else {
			return menu
		}


	}

	const remove_content_from_menu = async (id) => {
		return await reqGET(`${api_crud_base}/web/structure/${getTokenInfo().companycode}`)
			.then(res => {

				res.data.forEach((value) => {
					if(value.content !== undefined && value.content['childs'].length > 0) {

						value.content.childs = value.content.childs.filter(v => v.id_content !== id)
						remove_menu_childs(value.content.childs, id)

						reqPUT(`${api_crud_base}/web/structure`, value)
							.then(() => {
								//console.log('sucesso')
							})
							.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)

					}
				})
				
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {

				remove_content_from_menu(dados.current.id)

				reqDELETE(api_crud_route + '/', { id: dados.current.id })
					.then(() => {
						
						props.history.push(endpoints.list);

					})
					.catch(() => Swal.fire(language[lang].delete_error, '', 'info'))
			}
		})
	};

	const change_item_menu_childs = (menu, name, value, id) => {

		if(menu !== undefined && menu.length > 0) {
			menu.forEach((v) => {

				if(v.id_content === id) {
					v[name] = value
				}

				if(v.children !== undefined && v['children'].length > 0) {
					return change_item_menu_childs(v.children, name, value, id)
				}
				else {
					return menu
				} 
			})
		}
		else {
			return menu
		}
	}

	const change_item_from_menu = async (name, value, id) => {
		return await reqGET(`${api_crud_base}/web/structure/${getTokenInfo().companycode}`)
			.then(res => {

				res.data.forEach((v) => {
					if(v.content !== undefined && v.content['childs'].length > 0) {

						//console.log(v);
						change_item_menu_childs(v.content.childs, name, value, id)

						reqPUT(`${api_crud_base}/web/structure`, v)
							.then(() => {
								//console.log('sucesso')
							})
							.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)

					}
				})
				
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_info_slug = async (e) => {
		const { name, value } = e.target;

		if(value !== '') {

			let v = replace_slug_string(value)
			get_slug(v, 0)
				.then((res) => {
					if(res) {
						get_slug(v, 1)
							.then((res_2) => {
								set_dados(dados.current.info[name] = res_2)
								e.target.value = res_2

								// setRefresh(refresh + 1)
								// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
								// console.log('Dados Current:' + JSON.stringify(dados))
							})
					}
					else {
						set_dados(dados.current.info[name] = v)

						// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
						// console.log('Dados Current:' + JSON.stringify(dados))
					}
				})
		}
		else {
			set_dados(dados.current.info[name] = '')

			// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
			// console.log('Dados Current:' + JSON.stringify(dados))
		}
	}

	const handle_change_info_date = (e) => {
		const { name, value } = e.target;
		
		set_dados(dados.current.info.date[name] = value)

		if(name === 'published') {
			let date_publication = new Date(value); 
			set_date_publication(date_publication.getDate().toString().padStart(2, '0') + '/' + (date_publication.getMonth() + 1).toString().padStart(2, '0') + '/' + date_publication.getFullYear())
		}
		if(name === 'avaiable') {
			let date_avaiable = new Date(value); 
			set_date_avaiable(date_avaiable.getDate().toString().padStart(2, '0') + '/' + (date_avaiable.getMonth() + 1).toString().padStart(2, '0') + '/' + date_avaiable.getFullYear())
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_content = (e) => {
		const { name, value, dataset } = e.target;
		const { order, lang, langid } = dataset

		set_dados(dados.current.content[order][name] = value)
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}
	
	const handle_change_content_translate = (e) => {
		const { name, value, dataset } = e.target;
		const { order, lang, langid } = dataset

		dados.current.content[order][name] = []
		let value_aux = {}
		let aux = dados.current.content[order][name].filter(e => e[lang] !== undefined && e[lang] !== null)
		if(aux !== undefined && aux.length === 0) {
			value_aux[lang] = value
			dados.current.content[order][name].push(value_aux)
		}
		else {
			dados.current.content[order][name].forEach(el => {
				if(el[lang] !== undefined) {
					el[lang] = value
				}
			})
		}

		if(langid === '1') {
			if(name === 'title' && order === '0') {
				set_dados(dados.current.info.name = value)
				set_dados(dados.current.info.seo.title = value)
			}
		}
		
		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_content_align = (e, order, langid) => {
		const { name, value } = e.target;

		set_dados(dados.current.content[order]['align'][name] = value)
	}

	const handle_change_button = (e) => {
		console.log('0', e.target.value)
		if(e.target.value === 'true') {
			console.log('1')
			dados.current.info['button'] = true
		}
		else {
			console.log('2')
			dados.current.info['button'] = false
		}
	}

	const handle_change_content_link_input = (e) => {
		const { value, dataset } = e.target;
		const { order } = dataset

		//set_dados(dados.current.content[order]['connection']['link'] = value)

		dados.current.content[order]['connection']['link'] = value
		dados.current.content[order]['connection']['type'] = 'external'

		set_dados(dados.current.content[order]['connection'], )
		setRefresh(refresh + 1)
	}

	const handle_change_content_link_select = (e) => {
		const { value, dataset } = e.target;
		const { order } = dataset

		dados.current.content[order]['connection']['link'] = ''
		dados.current.content[order]['connection']['id'] = value

		let aux = menus_avaiable.filter(el => el.id === value)
		set_dados(dados.current.content[order]['connection']['type'] = aux[0].info.type)
		setRefresh(refresh + 1)
	}

	const handle_change_content_ckeditor = (value, order, langid, lang, name) => {
	
		console.log('handle_change_info_ckeditor');

		dados.current.content[order][name] = []
		let value_aux = {}
		let aux = dados.current.content[order][name].filter(e => e[lang] !== undefined && e[lang] !== null)
		if(aux !== undefined && aux.length === 0) {
			value_aux[lang] = value
			dados.current.content[order][name].push(value_aux)
		}
		else {
			dados.current.content[order][name].forEach(el => {
				if(el[lang] !== undefined) {
					el[lang] = value
				}
			})
		}

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const get_value_content_lang = (order, langid, name) => {
		if(dados.current.content[order]['language'] !== undefined && dados.current.content[order]['language'] !== null) {
			if(dados.current.content[order]['language'][langid] !== undefined && dados.current.content[order]['language'][langid] !== null) {
				return dados.current.content[order]['language'][langid][name];
			}
			else {
				return '';
			}
		}
		else {
			return '';
		}
	}

	const handle_change_info_seo = (e) => {
		const { name, value } = e.target;

		if(!dados.current.info.seo)
			dados.current.info.seo = {}

		set_dados(dados.current.info.seo[name] = value)
		
		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const get_slug = async (slug, i) => {
		if(i === 0) {
			return await reqGET(`${api_crud_base}/web/content/slug/${getTokenInfo().companycode}/${slug}`)
				.then(res => {
					if(res.data.length > 0) {
						if(props.location.state.item['id'] === res.data[0].id) {
							setSlug(false)
							return false

						}else{
							setSlug(true)
							return true
						}
					}
					else {
						setSlug(false)
						return false
					}
				})
				.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
		}
		else {
			return await reqGET(`${api_crud_base}/web/content/slug/${getTokenInfo().companycode}/${slug}-${i}`)
			.then(res => {
				if(res.data.length > 0) {
					//setSlug(true)
					return get_slug(slug, i + 1)
				}
				else {
					setSlug(false)
					return slug + '-' + i
				}
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
		}
	}

	const convertBase64 = async (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
        
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
        
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

	const onChangeHandlerFilesImage = async (e) => {
       	const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		if(langid === '1') {
			if(dados.current.content[order]['media'] === undefined)
				dados.current.content[order]['media'] = {image: [], doc: []}

			if(dados.current.content[order]['media']['image'] !== undefined)
				dados.current.content[order]['media']['image'] = []
		}
		else {
			if(dados.current.content[order]['language'] === undefined)
				dados.current.content[order]['language'] = []

			if(dados.current.content[order]['language'][langid] === undefined)
				dados.current.content[order]['language'][langid] = []

			if(dados.current.content[order]['language'][langid]['media'] === undefined)
				dados.current.content[order]['language'][langid]['media'] = {image: [], doc: []}

			if(dados.current.content[order]['language'][langid]['media'] === undefined)
				dados.current.content[order]['language'][langid]['media'] = {image: [], doc: []}

			if(dados.current.content[order]['language'][langid]['media']['image'] !== undefined)
				dados.current.content[order]['language'][langid]['media']['image'] = []
		}

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v, k) => {
			if((v.type.includes('image/')) && (v.size < 10485760)){

				handle_compressed_image_upload(v, (valor) => storedFiles.push(valor))
				//storedFiles.push(v);

				const base64 = await convertBase64(v);
				let files_img_aux = image_base64
				
				if(files_img_aux[order] === undefined)
					files_img_aux[order] = []
				if(files_img_aux[order][langid] === undefined)
					files_img_aux[order][langid] = []
				
				//files_img_aux[order][langid].push({id: '1', langid: langid, name: v.name, link: base64})
				files_img_aux[order][langid] = [{id: '1', langid: langid, name: v.name, link: base64}]
				set_image_base64(files_img_aux)

				// console.log('image_base64', image_base64)
				if(filesArray.length === (k + 1)) {
					set_dados(dados.current,)
					setRefresh(refresh + 1)
				}

			}
			else{
				Swal.fire('', v.name + '<br/><br/>' + language[lang].upload_file_error, 'info')
			}
		});	

		let files_aux = files_image
		files_aux.push({files: storedFiles, order: order, lang: lang, langid: langid})
		set_files_image(files_aux)

    }

	const uploadFilesImage = (files, order, type, langid, lang) => {

		let aux = []
        files.forEach(async (element) => {
			if(element.type.includes('image/')) {
				aux.push(element)

				let y = img_loader
				y.push('img')
				set_img_loader(y)

				await uploadFile(element, order, type, langid, lang)
				   .then(() => {
						//console.log('success')
				   })
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
        })
    }

	const onChangeHandlerFilesPDF = (e) => {
        const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if((v.type.includes('/pdf')) && (v.size < 10485760)){
				storedFiles.push(v);

				let aux2 = files_doc_name
				if(aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({name: v.name, size: v.size})
				set_files_doc_name(aux2)

				let aux_doc = treeData
				if(treeData[order] === undefined)
					treeData[order] =  []
				if(treeData[order][langid] === undefined)
					treeData[order][langid] =  []
				let i = treeData[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true})
				setTreeData(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else{
				Swal.fire('', v.name + '<br/><br/>' + language[lang].upload_file_error, 'info')
			}
		});	

		let files_aux = files_doc
		files_aux.push({files: storedFiles, order: order, lang: lang, langid: langid})
		set_files_doc(files_aux)
    }

	const uploadFilesDoc = (files, order, type, langid, lang) => {
        let aux = []
        files.forEach((element) => {
			if(element.type === "application/pdf") {
				aux.push(element)

				uploadFile(element, order, type, langid, lang)
				    .then(() => {
						//console.log('success')
				    })
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
        })
    }

    const uploadFile = async (file, order, type, langid, lang) => {
        const formData = new FormData()
        formData.append('files', file)
        formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
        formData.append('type', 'content')
        formData.append('companycode', dados.current.info.companycode)
        formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/content/');

        return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
            .then((res) => { 
                var today_file = new Date()

				let i = Date.now()

                let x = {
                    id: i,
                    info: {
                        companycode: getTokenInfo().companycode,
                        type: res.data.mimetype,
                        link: res.data.path + '/' + res.data.name,
                        size: res.data.size,
                        date: today_file
                    },
					content: {
						name: file.name,
                        description: '',
						lang: []
					}
                }

				if(langid === '1'){
					if(type === 'image') {
						dados.current.content[order]['media'][type].push({ 
							id: i,
							link: res.data.path + '/' + res.data.name,
							name: file.name,
							description: '',
							type: type,
							order: dados.current.content[order]['media'][type].length,
							lang: []
						})
					}
					if(type === 'doc') {
						dados.current.content[order]['media'][type].push({ 
							id: i,
							link: res.data.path + '/' + res.data.name,
							name: file.name,
							description: '',
							type: type,
							order: dados.current.content[order]['media'][type].length,
							lang: []
						})
					}
				}
				else {
					if(type === 'image') {
						dados.current.content[order]['language'][langid]['media'][type].push({ 
							id: i,
							link: res.data.path + '/' + res.data.name,
							name: file.name,
							description: '',
							type: type,
							order: dados.current.content[order]['language'][langid]['media'][type].length,
							lang: []
						})
					}
					if(type === 'doc') {
						dados.current.content[order]['language'][langid]['media'][type].push({ 
							id: i,
							link: res.data.path + '/' + res.data.name,
							name: file.name,
							description: '',
							type: type,
							order: dados.current.content[order]['language'][langid]['media'][type].length,
							lang: []
						})
					}
				}

				reqPUT(api_crud_route, dados.current)
					.then(() => { 
						//props.history.push(endpoints.list) 

						reqPOST(`${api_crud_base}/multimedia`, x)
							.then(() => { 

								let y2 = img_loader
								y2.pop()
								set_img_loader(y2)
								setRefresh(i)

							})
							.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

                
                
				return true

            })
            .catch(erro => console.log('Erro POST File: ' + erro))
    }

	const add_content = () => {
		
		dados.current.content.push(data_interface.content[0])
		set_dados(dados.current.content)
		setEditorLoaded(false);
		setRefresh(refresh + 1)

		setTimeout(
            function() { 
				setEditorLoaded(true);
            }
        , 1000);

		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_tree = (tD, order, langid) => {

		treeData[order][langid] = tD

		let aux = []
		if(langid === '1') {
			treeData[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if(el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeData(treeData)
		}
		else {
			treeData[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if(el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeData(treeData)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const open_link = (url) => {
		window.open(url, '_blank');
	}

	const copy_clipboard = (url) => {
		navigator.clipboard.writeText(url)

		Swal.fire({
			icon: '',
			title: '',
			text: 'Copiado',
			showConfirmButton: false,
			timer: 1000
		})
	}

	const remove_element_tree = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {

				let treeAux = treeData[order][langid].filter(v => v.id !== id)
				treeData[order][langid] = treeAux
				setTreeData(treeData)

				let aux = []
				if(langid === '1') {
					dados.current.content[order].media.doc.forEach((el) => {
						if(el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.content[order].media.doc = aux)
				}
				else {
					dados.current.content[order]['language'][langid].media.doc.forEach((el) => {
						if(el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
				}

			}
		})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree = (e) => {
		const { value, dataset } = e.target;
		const { order, id, doc } = dataset

		treeData[order].forEach((el) => {
			if(el.id === id) {
				el.title = value

				dados.current.content[order].media.doc.forEach((el_2) => {
					if(el_2.id === doc)
						el_2.name = value
				})
			}
		})
		setTreeData(treeData)
	}

	const handleTagDelete = i => {
		let tags = dados.current.info['tags'].filter((tag, index) => index !== i)

		set_dados(dados.current.info['tags'] = tags)
	};
	
	const handleTagAddition = tag => {
		set_dados(dados.current.info['tags'].push(tag))

		let aux = suggestions.filter(v => v.id === tag.id)
		if(aux.length === 0) {
			let suggestions_aux = suggestions
			suggestions_aux.push(tag)
			set_suggestions(suggestions_aux)

			reqPOST(`${api_crud_base}/web/category`, {id: '', info: {name: tag.text, color: '', lang:[], status: true, companycode: getTokenInfo().companycode}})
				.then(() => { 
					//console.log('Categoria inserida com sucesso!')
				})
				.catch(() => {
					//console.log('Problema ao inserir Categoria!')
				})
		}
	};

	const handleTagDrag = (tag, currPos, newPos) => {
		const newTags = tags.slice();

		newTags.splice(currPos, 1);
		newTags.splice(newPos, 0, tag);

		// re-render
		setTags(newTags);
		};

	const handleTagClick = index => {
		//console.log('The tag at index ' + index + ' was clicked');
	};

	return (
		isloading ?
			<Loader />
		:
			<main>
				<form id="form" onSubmit={handleSubmit}>
					<input type="hidden" name="id" value={dados.current.id} />

					<div className={`dash-cards header`}>
						<div className="container">
							<h2 className="dash-title">{language[lang].banners}</h2>
							<p>{language[lang].banners} / { dados.current.id !== '' ? language[lang].banners_edit : language[lang].banners_new }</p>
						</div>
					</div>

					<div className={`dash-cards body`}>
						<div className="container">
							<div className="row">
								<div className="col-md-8 mb-5 mb-xl-10">
									
									<div className="tab-content" id="tabContent">
										{
										dados.current.info.layout !== 'normal' ?
											<>
												<div className="card mb-3">
													<div className="card-header border-0">
														<ul className="nav nav-tabs nav-line-tabs border-bottom-0 mt-2 mb-1 fs-6">
															<li className="nav-item mb-1 me-1">
																<button type="button" onClick={() => add_content()} className="btn btn-sm btn-secondary rounded-0 multi-item">
																	<span>{language[lang].content_add}</span>
																</button>	
															</li>
															{
															dados.current.content.length > 1 ?
																dados.current.content.map((el, k) => {
																	return (
																		<li key={k} className="nav-item mb-1">
																			<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_content_" + k}>{k + 1}</a>
																		</li>

																	)
																})
															:
																''
															}
														</ul>
													</div>
												</div>
											</>
										:
											null
										}
									
										{
										dados.current.content.map((el, k) => {
											return (
												<div key={k} className={"tab-pane  " + (k === 0 ? " show active" : '')} id={"tab_pane_content_" + k} role="tabpanel">

													<div className="card">
														<div className="card-header border-0 d-flex justify-content-sm-between px-4 py-3">
															<div className="card-title m-0">
																<h3 className="fw-bolder m-0">{language[lang].content}</h3>
															</div>
															<div className="card-toolbar">
																<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
																	{
																	content_language.length > 1 ?
																		content_language.map((el_lang, k_lang) => {
																			return (
																				<li key={k_lang} className="nav-item">
																					<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_content_" + k + "_language_" + k_lang}>{el_lang.code}</a>
																				</li>
																			)
																		})
																	:
																		null
																	}
																</ul>
															</div>
														</div>
														<div id="div-content" >
															<div className="card-body border-top p-4">
																<div className="tab-content" id={"tabContentLang_" + k} >
																	{
																	content_language.length > 0 ?
																		content_language.map((el_lang, k_lang) => {
																			return (
																				<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"tab_pane_content_" + k +  "_language_" + k_lang} role="tabpanel">

																					<div className="row mb-2">
																						<div className="col-12">
																							<label className={k === 0 && el_lang.id === '1' ? "col-form-label fw-bold fs-6" : "col-form-label fw-bold fs-6"}>{language[lang].title} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																							<input type="text" name="title" data-order={k} data-langid={el_lang.id} data-lang={el_lang.code} value={translate(el.title, el_lang.code)} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].title_placeholder} onChange={handle_change_content_translate} />
																						</div>
																					</div>
																					<div className="row mb-2">
																						<div className="col-12">
																							<label className="col-form-label fw-bold fs-6">{language[lang].subtitle} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																							<input type="text" name="subtitle" data-order={k} data-langid={el_lang.id} data-lang={el_lang.code} value={translate(el.subtitle, el_lang.code)} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].subtitle_placeholder} onChange={handle_change_content_translate} />
																						</div>
																					</div>

																					<div className="row mb-3">
																						<div className="col-12">
																							<label className="col-form-label fw-bold fs-6">{language[lang].link}</label>
																						</div>
																						<div className="col-4">
																							<input type="text" name="link" data-order={k} data-langid={'1'} data-lang={'pt'} value={el.connection.id === '' ? el.connection.link: ''} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].link_placeholder} onChange={handle_change_content_link_input} readOnly={el.connection.id !== '' ? true : false} />
																						</div>

																						<div className="col-4">
																							<select className="form-select rounded-0" aria-label="Select link" name='link' data-order={k} data-langid={'1'} data-lang={'pt'}  value={el.connection.id} onChange={handle_change_content_link_select}>
																								<option value="">{language[lang].choose_link}</option>
																								{
																								menus_avaiable.map((v, k) => {
																									if (v.id === dados.current.id)
																										return ''
																									if (v.id === '')
																										return (
																											<option key={k} value={v.id} disabled>{v.info.name}</option>
																										)

																									return (
																										<option key={k} value={v.id}>{v.info.name}</option>
																									)
																								})
																								}
																							</select>
																						</div>

																						<div className={"col-4" + (el.connection.id !== '' || el.connection.link !== '' ? '' : ' d-none')}>
																							<div className="">
																								<input
																									id={"radio_" + k + "_" + el_lang.id + "_0"}
																									type="radio"
																									name={"button_" + k + "_" + el_lang.id}
																									value="true"
																									defaultChecked={dados.current.info['button']}
																									onClick={handle_change_button} 
																								/>
																								<label className="assec-pl-5" htmlFor={"radio_" + k + "_" + el_lang.id + "_0"}>{language[lang].choose_link_button}</label>
																							</div>

																							<div className="">
																								<input
																									id={"radio_" + k + "_" + el_lang.id + "_1"}
																									type="radio"
																									name={"button_" + k + "_" + el_lang.id}
																									value="false"
																									defaultChecked={!dados.current.info['button']}
																									onClick={handle_change_button} 
																								/>
																								<label className="assec-pl-5" htmlFor={"radio_" + k + "_" + el_lang.id + "_1"}>{language[lang].choose_link_image}</label>
																							</div>
																						</div>

																					</div>

																					<div className="row mb-3">
																						<div className="col-12">
																							<label className="col-form-label fw-bold fs-6">{language[lang].align}</label>
																						</div>
																						<div className="col-6">
																							<label className="col-form-label fw-bold fs-6">{language[lang].align_vertical}</label>
																							<select className="form-select rounded-0" aria-label="Select Vertical Align" name='vertical' value={dados.current.content[k].align.vertical} onChange={(e) => handle_change_content_align(e, k, el_lang.id)}>
																								<option value="top">{language[lang].align_vertical_top}</option>
																								<option value="middle">{language[lang].align_vertical_middle}</option>
																								<option value="bottom">{language[lang].align_vertical_bottom}</option>
																							</select>
																						</div>

																						<div className="col-6">
																							<label className="col-form-label fw-bold fs-6">{language[lang].align_horizontal}</label>
																							<select className="form-select rounded-0" aria-label="Select Horizontal Align" name='horizontal' value={dados.current.content[k].align.horizontal} onChange={(e) => handle_change_content_align(e, k, el_lang.id)}>
																								<option value="left">{language[lang].align_horizontal_left}</option>
																								<option value="center">{language[lang].align_horizontal_center}</option>
																								<option value="right">{language[lang].align_horizontal_right}</option>
																							</select>
																						</div>
																					</div>

																					<div className="row mb-5 d-none">
																						<div className="col-12">
																							<label className="col-form-label fw-bold fs-6">{language[lang].text} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																							<ASSECCKEditor
																								name={"text-" + k}
																								content={el_lang.id === '1' ? el.text : get_value_content_lang(k, el_lang.id, 'text')}
																								func={(e) => handle_change_content_ckeditor(e, k, el_lang.id, el_lang.code, 'text')}
																							/>
																							<textarea className="form-control mb-3 mb-lg-0 d-none" name="text" data-order={k} data-langid={el_lang.id} data-lang={el_lang.code} value={el_lang.id === '1' ? el.text : get_value_content_lang(k, el_lang.id, 'text') } rows="4" onChange={handle_change_content} />
																						</div>
																					</div>

																					

																					<div className="row mb-2">
																						<div className="col-12">
																							<div className="div-image">
																								<label className="col-form-label fw-bold fs-6">{language[lang].images}</label>

																								<div className="dropzone-panel mb-2">
																									<div className="div-form-input col-12 custom-file">
																										<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-content-" + k + "-" + el_lang.id}>{language[lang].image_choose}</label>
																										<input 
																											id={"input-files-content-" + k + "-" + el_lang.id}
																											type="file" 
																											accept="image/*"
																											data-order={k}
																											data-langid={el_lang.id}
																											data-lang={el_lang.code}
																											data-type={'image'}
																											className="dropzone-select btn btn-sm btn-primary me-2 d-none" 
																											onChange={onChangeHandlerFilesImage}
																										/> 
																									</div>
																								</div>

																								<button type="button" className="btn btn-sm btn-primary mb-2 d-none" data-bs-toggle="modal" data-bs-target={"#modal_media_image_bloco_" + k}>
																									{language[lang].image_choose}
																								</button>

																								<div className="row">
																									{
																									el_lang.id === '1' && el['media'] !== undefined && el['media']['image'] !== undefined && el['media']['image'].length > 0 ?
																										<>
																											{
																											el['media']['image']
																												.sort((a, b) => a.order - b.order) 
																												.map((el_media, k_media) => {
																													if(image_base64[k] === undefined || image_base64[k][el_lang.id] === undefined || image_base64[k][el_lang.id].filter((x) => x.name === el_media.name).length === 0) {
																														return (
																															<DraggableDivImage
																																key={k_media}
																																divNumber={k_media}
																																idImage={el_media.id}
																																linkImage={el_media.link}
																																nameImage={el_media.name}
																																urlImage={el_media.url}
																																descImage={el_media['description']}
																																contentOrder={k}
																																language={language}
																																lang={lang}
																																langid={el_lang.id}

																																data-order={k}
																																data-langid={el_lang.id}
																																data-id={k_media}

																																handleDrag={handleDrag}
																																handleDragOver={handleDragOver}
																																handleDrop={handleDrop}
																																handleRemove={() => handleRemove(k, el_lang.id, el_media.id, el_media.link)}
																																handleEdit={() => handleEdit(k)}
																																handleChangeContentMediaImage={(e) => handleChangeContentMediaImage(e)}
																															/>
																														)
																													}
																													else {
																														return ''
																													}
																												})
																											}
																											{
																												image_base64 !== undefined && image_base64[k] !== undefined && image_base64[k][el_lang.id] !== undefined ?
																													image_base64[k][el_lang.id].map((el_media, k_media) => {
																														return (
																															<DraggableDivImage
																																key={k_media}
																																divNumber={k_media}
																																idImage={el_media.id}
																																linkImage={el_media.link}
																																nameImage={el_media.name}
																																urlImage={el_media.url}
																																descImage={el_media['description']}
																																contentOrder={k}
																																language={language}
																																lang={lang}
																																langid={el_lang.id}

																																data-order={k}
																																data-langid={el_lang.id}
																																data-id={k_media}

																																handleDrag={handleDrag}
																																handleDragOver={handleDragOver}
																																handleDrop={handleDrop}
																																handleRemove={() => handleRemove(k, el_lang.id, el_media.id, el_media.link)}
																																handleEdit={() => handleEdit(k)}
																																handleChangeContentMediaImage={(e) => handleChangeContentMediaImage(e)}
																															/>
																														)
																													})
																												:
																													null
																											}
																										</>
																									:
																										(
																										el['language'] !== undefined && el['language'].length > 0 && el['language'][el_lang.id] !== undefined && el['language'][el_lang.id] !== null && el['language'][el_lang.id]['media'] !== undefined && el['language'][el_lang.id]['media']['image'] !== undefined ?
																											<>
																												{
																													el['language'][el_lang.id]['media']['image'].map((el_media, k_media) => {
																														if(image_base64[k] === undefined || image_base64[k][el_lang.id] === undefined || image_base64[k][el_lang.id].filter((x) => x.name === el_media.name).length === 0) {
																															return (
																																<DraggableDivImage
																																	key={k_media}
																																	divNumber={k_media}
																																	idImage={el_media.id}
																																	linkImage={el_media.link}
																																	nameImage={el_media.name}
																																	urlImage={el_media.url}
																																	descImage={el_media['description']}
																																	contentOrder={k}
																																	language={language}
																																	lang={lang}
																																	langid={el_lang.id}

																																	data-order={k}
																																	data-langid={el_lang.id}
																																	data-id={k_media}

																																	handleDrag={handleDrag}
																																	handleDragOver={handleDragOver}
																																	handleDrop={handleDrop}
																																	handleRemove={() => handleRemove(k, el_lang.id, el_media.id, el_media.link)}
																																	handleEdit={() => handleEdit(k)}
																																	handleChangeContentMediaImage={(e) => handleChangeContentMediaImage(e)}
																																/>
																															)
																														}
																														else {
																															return null
																														}
																													})
																												}

																												{
																													image_base64 !== undefined && image_base64[k] !== undefined && image_base64[k][el_lang.id] !== undefined ?
																														image_base64[k][el_lang.id].map((el_media, k_media) => {
																															return (
																																<DraggableDivImage
																																	key={k_media}
																																	divNumber={k_media}
																																	idImage={el_media.id}
																																	linkImage={el_media.link}
																																	nameImage={el_media.name}
																																	urlImage={el_media.url}
																																	descImage={el_media['description']}
																																	contentOrder={k}
																																	language={language}
																																	lang={lang}
																																	langid={el_lang.id}

																																	data-order={k}
																																	data-langid={el_lang.id}
																																	data-id={k_media}

																																	handleDrag={handleDrag}
																																	handleDragOver={handleDragOver}
																																	handleDrop={handleDrop}
																																	handleRemove={() => handleRemove(k, el_lang.id, el_media.id, el_media.link)}
																																	handleEdit={() => handleEdit(k)}
																																	handleChangeContentMediaImage={(e) => handleChangeContentMediaImage(e)}
																																/>
																															)
																														})
																														:
																														null
																												}
																											</>
																										:
																											<>
																												{
																												image_base64 !== undefined && image_base64[k] !== undefined && image_base64[k][el_lang.id] !== undefined ?
																													image_base64[k][el_lang.id].map((el_media, k_media) => {
																														return (
																															<DraggableDivImage
																																key={k_media}
																																divNumber={k_media}
																																idImage={el_media.id}
																																linkImage={el_media.link}
																																nameImage={el_media.name}
																																urlImage={el_media.url}
																																descImage={el_media['description']}
																																contentOrder={k}
																																language={language}
																																lang={lang}
																																langid={el_lang.id}

																																data-order={k}
																																data-langid={el_lang.id}
																																data-id={k_media}

																																handleDrag={handleDrag}
																																handleDragOver={handleDragOver}
																																handleDrop={handleDrop}
																																handleRemove={() => handleRemove(k, el_lang.id, el_media.id, el_media.link)}
																																handleEdit={() => handleEdit(k)}
																																handleChangeContentMediaImage={(e) => handleChangeContentMediaImage(e)}
																															/>
																														)
																													})
																												:
																														null
																												}
																											</>
																										)
																									}

																									{
																									img_loader.map((_, k_loader) => {
																										return (
																											<div key={k_loader} className="col-6 col-sm-4 mb-3 position-relative text-center">
																												<div className="spinner-border mt-5" role="status">
																													<span className="visually-hidden">Loading...</span>
																												</div>
																											</div>
																										)
																									})
																									}
																								</div>
																							</div>
																						</div>
																					</div>

																					<div className="row mb-5 d-none">
																						<div className="col-12">
																							<div className="div-doc">
																								<label className="col-form-label fw-bold fs-6">{language[lang].pdf_documents}</label>

																								<div className="dropzone-panel mb-lg-0 mb-2">
																									<div className="div-form-input col-12 custom-file">
																										<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-pdf-" + k + '-' + el_lang.id}>{language[lang].doc_choose}</label>
																										<input 
																											id={"input-files-pdf-" + k + '-' + el_lang.id}
																											type="file" 
																											accept="application/pdf"
																											data-order={k}
																											data-langid={el_lang.id}
																											data-lang={el_lang.code}
																											data-type={'doc'}
																											className="dropzone-select btn btn-sm btn-primary me-2 d-none" 
																											onChange={onChangeHandlerFilesPDF}
																											multiple
																										/> 
																									</div>
																								</div>

																								<div className="row">
																									{
																									treeData[k] !== undefined && treeData[k][el_lang.id] !== undefined ?
																										<SortableTree
																											isVirtualized={false}
																											treeData={treeData[k][el_lang.id]}
																											maxDepth={1}
																											//onChange={() => console.log('onChange')}
																											onChange={treeData => handle_change_tree(treeData, k, el_lang.id)}
																											getNodeKey={({ node }) => node.id}
																											generateNodeProps={extendedNode => ({
																												title: (
																													<input type="text" className="form-control form-control-sm rounded-0" defaultValue={extendedNode.node.title} data-order={k} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} onBlur={edit_element_tree} />
																												),
																												buttons: [
																													<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																													<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																													<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash' )}></i></button>,
																													<button type="button" onClick={() => remove_element_tree(k, el_lang.id, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																												],
																											})}
																										/>
																									: 
																										''
																									}
																								</div>
																							</div>
																						</div>
																					</div>
																				</div>
																			)
																		})
																	: 
																		''
																	}
																</div>
															</div>
														</div>
													</div>
												</div>
											)
										})
										}
									</div>
								</div>

								<div className="col-md-4 mb-5 mb-xl-10">
									<div className="card mb-5">
										<div className="card-header border-0 cursor-pointer px-4 py-3" role="button" data-bs-toggle="collapse" data-bs-target="#div_configuracao" aria-expanded="true" aria-controls="div_configuracao">
											<div className="card-title m-0">
												<h3 className="fw-bolder m-0">{language[lang].page_config}</h3>
											</div>
										</div>
										<div id="div_configuracao" className="collapse show">
											<div className="card-body border-top p-4">

												<div className="mb-3 d-none">
													<label className="col-form-label required fw-bold fs-6">{language[lang].name}</label>
													<input type="text" name="name" value={dados.current.info ? dados.current.info.name : ''} className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].name_placeholder} onChange={handle_change_info} required />
												</div>

												<div className="mb-3 d-none">
													<label className="col-form-label fw-bold fs-6">Categorias</label>
													<ReactTags
														tags={dados.current.info ? dados.current.info['tags'] : []}
														className={"form-control rounded-0 mb-3 mb-lg-0"}
														suggestions={suggestions}
														delimiters={delimiters}
														handleDelete={handleTagDelete}
														handleAddition={handleTagAddition}
														handleDrag={handleTagDrag}
														handleTagClick={handleTagClick}
														inputFieldPosition="top"
														placeholder={language[lang].choose_category}
														autocomplete
													/>
												</div>

												<div className="mb-3 d-none">
													<label className="col-form-label fw-bold fs-6">Slug do URL <small>(friendly url)</small></label>
													<div className="input-group input-group-sm mb-5 p-0">
														<span className="input-group-text rounded-0" id="basic-addon3">/</span>
														<input type="text" name="slug" value={dados.current.info ? dados.current.info.slug : ''} onChange={handle_change_info} onBlur={handle_change_info_slug} className="form-control rounded-0" id="basic-url" aria-describedby="basic-addon3" />
													</div>
												</div>

												<div className="mb-3">
													<label className="col-form-label fw-bold fs-6">{language[lang].schedule}</label>
													
													<input type="datetime-local" className="form-control rounded-0" name="published" value={dados.current.info.date.published !== '' ? dados.current.info.date.published : ''} onChange={handle_change_info_date} />
												</div>
												<div className="mb-3">
													<label className="col-form-label fw-bold fs-6">{language[lang].avaiable}</label>
													
													<input type="datetime-local" className="form-control rounded-0" name="avaiable" value={dados.current.info.date.avaiable !== '' ? dados.current.info.date.avaiable : ''} onChange={handle_change_info_date} />
												</div>

												<div className="">
													<label className="col-form-label fw-bold fs-6 d-none">{language[lang].dates}</label>
													<p style={{lineHeight: '1.75'}}>
														<strong>{language[lang].date_creation}:</strong> {date_creation !== '' ? date_creation : ''}<br />
														<strong>{language[lang].date_publication}:</strong> {date_publication !== '' ? date_publication : ''}<br />
														<strong>{language[lang].date_avaiable}:</strong> {date_avaiable !== '' ? date_avaiable : ''}<br />
														<strong>{language[lang].date_last_update}:</strong> {date_modification !== '' ? date_modification : ''}
													</p>
												</div>
											</div>
										</div>
									</div>
									
									<div className="card mb-5">
										<div className="card-header border-0 cursor-pointer px-4 py-3" role="button" data-bs-toggle="collapse" data-bs-target="#div_seo" aria-expanded="true" aria-controls="div_seo">
											<div className="card-title m-0">
												<h3 className="fw-bolder m-0">{language[lang].seo_config}</h3>
											</div>
										</div>
										<div id="div_seo"  className="collapse show">
											<div className="card-body border-top p-4">
												<div className="mb-3">
													<label className="col-form-label fw-bold fs-6">{language[lang].seo_title}</label>
													<input type="text" name="title" value={dados.current.info.seo ? dados.current.info.seo.title : ''} className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].seo_title_placeholder} onChange={handle_change_info_seo} />
												</div>

												<div className="mb-3">
													<label className="col-form-label fw-bold fs-6">{language[lang].seo_keywords} <small>{language[lang].seo_keywords_small}</small></label>
													<input type="text" name="keywords" value={dados.current.info.seo ? dados.current.info.seo.keywords : ''} className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].seo_keywords_placeholder} onChange={handle_change_info_seo} />
												</div>

												<div className="">
													<label className="col-form-label fw-bold fs-6">{language[lang].seo_description}</label>
													<textarea type="text" name="description" value={dados.current.info.seo ? dados.current.info.seo.description : ''} className="form-control rounded-0 mb-3 mb-lg-0" placeholder={language[lang].seo_description_placeholder} onChange={handle_change_info_seo} />
												</div>
											</div>

										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className={'dash-cards footer'}>
						<nav className="navbar bottom-navbar navbar-light">
							<div className="navbar-footer">
								<ul className="navbar-nav float-left"></ul>
								<ul className="navbar-nav float-right">
									<li className="nav-item">
										<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
											<i className="bi bi-chevron-left me-2"></i>
											<span>{language[lang].back}</span>
										</Link>
									</li>
									<li className={"nav-item " + show_delete_button}>
										<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
											<i className="bi bi-trash me-2 text-white" />
											<span>{language[lang].delete}</span>
										</button>
									</li>
									<li className="nav-item">
										<button type="submit" form="form" className="nav-link">
											<i className="bi bi-floppy me-2"></i>
											<span>{language[lang].save}</span>
										</button>
									</li>
								</ul>
							</div>
						</nav>
					</div>
				</form>
			</main>
	)

}
